import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import "./searchInput.css";
import { useAppSelector } from "hooks/reduxToolkit";
import ValidationMessege from "./assets/ValidationMessege";

type autoCompleteProps = {
  searchKeyword: string;
  setSearchKeyword: (keyword: string) => void;
  setHandleSearch: (value: boolean) => void;
  handleSearch: boolean;
};

const SearchInput = ({
  searchKeyword,
  setSearchKeyword,
  setHandleSearch,
  handleSearch,
}: autoCompleteProps) => {
  const { t } = useTranslation();
  const [input, setInput] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const { hasReports } = useAppSelector((state) => state.reportsSliceReducer);

  const onChange = (e: { target: { value: string } }) => {
    const onChangeInput = e.target.value;
    setValidationMessage("");
    const numbers = /^[0-9]*$/;
    if (!onChangeInput.match(numbers)) {
      setValidationMessage(t("onlyNumberValidaionMessage"));
    }

    setInput(onChangeInput);
  };

  // Handle Enter key press
  const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setSearchKeyword(input);
    }
  };

  useEffect(() => {
    if (handleSearch) {
      setSearchKeyword(input);
      setHandleSearch(false);
    }
  }, [handleSearch, input, setHandleSearch, setSearchKeyword]);

  useEffect(() => {
    if (searchKeyword === "") {
      setInput("");
    }
  }, [searchKeyword]);

  return (
    <>
      <input
        type="text"
        onChange={onChange}
        onKeyDown={onKeyPress}
        value={input}
        className="searchHeader"
        placeholder={t("searchByReportNumber")}
      />
      {searchKeyword && validationMessage && (
        <ValidationMessege
          className="no-autocomplete"
          validationMessage={validationMessage}
          validationMessageClass="error"
        />
      )}
      {searchKeyword && !hasReports && (
        <ValidationMessege
          className="no-autocomplete"
          validationMessage={validationMessage}
          validationMessageClass="error"
        />
      )}
    </>
  );
};
export default SearchInput;
